@for (divider of dividers(); track divider.id) {
    <svg
        [class]="divider.cssClass"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        preserveAspectRatio="none"
        shape-rendering="geometricPrecision"
        [attr.fill]="divider.fill"
        [attr.height]="divider.height"
    >
        <defs>
            <pattern
                [id]="divider.id"
                x="0"
                y="0"
                [attr.width]="divider.patternWidth"
                height="101%"
                viewBox="0 0 1920 100"
                preserveAspectRatio="none"
            >
                <mask
                    [id]="'mask_' + divider.id"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="1920"
                    height="100"
                >
                    <rect width="1920" height="100" />
                </mask>
                <g [attr.mask]="'url(#mask_' + divider.id + ')'" [innerHTML]="divider.markup | spSafeHtml"></g>
            </pattern>
        </defs>
        <rect x="0" y="0" width="100%" height="100%" [attr.fill]="'url(#' + divider.id + ')'" />
    </svg>
}
